import React, { useState, useEffect, useRef } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    OutlinedInput,
    Checkbox,
    ListItemText,
    Tooltip
} from '@mui/material';
import styles from './MultiSelectWithInput.module.css';

const MultiSelectWithSearchInput2 = ({ label, options = [], filterValues, handleFilter, disabled, isLabelShow = true, type }) => {
    const [selectedValues, setSelectedValues] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filteredOptions, setFilteredOptions] = useState(options?.slice(0, 50));
    const [labelTruncation, setLabelTruncation] = useState(false);
    const labelRef = useRef(null);
    const compRef = useRef(null);

    useEffect(() => {
        if (filterValues?.[label]?.length) {
            setSelectedValues(filterValues[label]);
        } else {
            setSelectedValues(filterValues);
        }
    }, [filterValues, label, options]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            const filtered = options.filter((opt) =>
                opt.toLowerCase().includes(searchText.toLowerCase())
            );
            setFilteredOptions(searchText ? filtered.slice(0, 50) : options.slice(0, 50));
        }, 300);
        return () => clearTimeout(timeout);
    }, [searchText, options]);

    // if label is truncated then only tooltip will show
    useEffect(() => {
        setLabelTruncation(labelRef.current.scrollWidth > labelRef.current.clientWidth)
    }, [label])

    const handleFilterClick = (event) => {
        const value = event.target.value;

        if (value.includes('Select all')) {
            const allSelected = selectedValues.length === options.length;
            const newSelectedValues = allSelected ? [] : options;
            setSelectedValues(newSelectedValues);
            handleFilter(label, newSelectedValues);
        } else {
            setSelectedValues(value);
            handleFilter(label, value);
        }
    };

    const handleSearchChange = (event) => {
        const newSearchTerm = event.target.value.toLowerCase();
        setSearchText(newSearchTerm);
        setSearchText(event.target.value);
    };


    // Handle outside clicks
    const handleClickOutside = (event) => {
        if (compRef.current && !compRef.current.contains(event.target)) {
            setSearchText('');
        }
    };

    // Add event listener on mount
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            // Cleanup on unmount
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const isAllSelected = selectedValues.length === options.length;

    const isChecked = (opt) => selectedValues.includes(opt);
    return (
        <div className={styles.labelFilterGroup} ref={compRef}>
            <Tooltip title={labelTruncation ? label : ''} placement='top'>
                <label ref={labelRef} className={styles.label} style={{ color: disabled ? "rgb(77 77 79 / 42%)" : '#4D4D4F' }}>
                    {isLabelShow ? label : ''}
                </label>
            </Tooltip>
            <FormControl fullWidth>
                <Select
                    id={`${label}-select`}
                    className={styles.filterFields}
                    multiple
                    displayEmpty
                    value={selectedValues}
                    onChange={handleFilterClick}
                    disabled={disabled}
                    input={
                        <OutlinedInput />
                    }
                    renderValue={() => {
                        if (selectedValues.length === 0) {
                            // return 'All';
                            return isLabelShow ? 'All' : label;
                        } else if (selectedValues.length === options.length) {
                            return 'All';
                        } else {
                            return selectedValues.join(', ');
                        }
                    }}
                    MenuProps={{
                        autoFocus: false,
                        PaperProps: {
                            style: {
                                maxHeight: '200px',
                            },
                        },
                    }}
                >
                    {
                        <MenuItem key="search" sx={{ padding: 0, borderBottom: '1px solid #ccc', '&.MuiMenuItem-root:hover': { backgroundColor: 'transparent' } }}>
                            <input type="text"
                                placeholder="Search..."
                                value={searchText}
                                onChange={handleSearchChange}
                                className={styles.SearchInput}
                                onClick={(e) => e.stopPropagation()}
                                onKeyDown={(e) => e.stopPropagation()}
                                style={{ border: 'none', height: '30px', width: '100%', paddingLeft: '5px' }}
                            />
                        </MenuItem>}
                    <MenuItem value="Select all" sx={{
                        padding: '5px',
                        '& .MuiTypography-root': {
                            fontSize: '12px',
                        },
                    }}>
                        <Checkbox checked={isAllSelected} sx={{ padding: '2px' }} />
                        <ListItemText primary="Select all" />
                    </MenuItem>
                    {filteredOptions.map((opt, ind) => {
                        return (
                            <MenuItem key={`${opt}_${ind}`} value={opt} sx={{
                                padding: '5px',
                                '& .MuiTypography-root': {
                                    fontSize: '12px',
                                },
                            }}>
                                <Checkbox checked={isChecked(opt)} sx={{ padding: '2px' }} />
                                <ListItemText primary={opt} />
                            </MenuItem>

                        );
                    })}
                </Select>
            </FormControl>
        </div>
    );
};
export default MultiSelectWithSearchInput2;